package pl.michal_cyran.brand_hub.subpages.dayMathAd.sections

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.width
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.silk.components.icons.fa.FaChartSimple
import com.varabyte.kobweb.silk.components.icons.fa.FaClock
import com.varabyte.kobweb.silk.components.icons.fa.FaDumbbell
import com.varabyte.kobweb.silk.components.layout.SimpleGrid
import com.varabyte.kobweb.silk.components.layout.numColumns
import com.varabyte.kobweb.silk.components.text.SpanText
import com.varabyte.kobweb.silk.style.toModifier
import com.varabyte.kobweb.silk.theme.colors.ColorMode
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.dom.H1
import org.jetbrains.compose.web.dom.P
import org.jetbrains.compose.web.dom.Text
import pl.michal_cyran.brand_hub.HeroGridStyle
import pl.michal_cyran.brand_hub.components.widgets.DeviceMockup
import pl.michal_cyran.brand_hub.components.widgets.VisibilityAware
import pl.michal_cyran.brand_hub.components.widgets.revealFadeSlideUp
import pl.michal_cyran.brand_hub.components.widgets.revealFadeSlideUpScale
import pl.michal_cyran.brand_hub.components.widgets.staggerDelay
import pl.michal_cyran.brand_hub.toSitePalette

@Composable
fun DayMathProgressTracking() {
    val cm = ColorMode.current.toSitePalette()

    SimpleGrid(
        numColumns(base = 1, md = 2),
        HeroGridStyle.toModifier()
    ) {
        VisibilityAware(
            modifier = Modifier.width(100.percent)
        ) { isVisible ->
            Column(
                modifier = Modifier
                    .width(100.percent)
                    .revealFadeSlideUpScale(
                        isVisible,
                        delayMs = 200,
                        distance = 32.px,
                        fromScale = 0.92
                    ),
                horizontalAlignment = Alignment.CenterHorizontally,
                verticalArrangement = Arrangement.Center,
            ) {
                DeviceMockup("daymath_ss/profile")
            }
        }

        VisibilityAware(modifier = Modifier) { isVisible ->
            Column {
                H1(
                    Modifier
                        .revealFadeSlideUp(isVisible, delayMs = 0)
                        .toAttrs()
                ) {
                    SpanText(
                        "Śledź swoje ",
                        modifier = Modifier.color(cm.textMuted)
                    )
                    SpanText(
                        "postępy.",
                        modifier = Modifier.color(cm.primary)
                    )
                }

                P(
                    Modifier
                        .revealFadeSlideUp(isVisible, delayMs = 120)
                        .toAttrs()
                ) {
                    Text("Zyskaj pełny wgląd w swoją wiedzę. Analizuj mocne strony i nadrabiaj zaległości dzięki zaawansowanym statystykom. ")
                }

                val features = listOf(
                    @Composable{ FaClock() } to "Historia postępów",
                    @Composable{ FaChartSimple() } to "Wykresy wydajności",
                    @Composable{ FaDumbbell() } to " Regulowany poziom trudności "
                )

                features.forEachIndexed { index, (icon, text) ->
                    FeatureRow(
                        icon = icon,
                        text = text,
                        modifier = Modifier
                            .revealFadeSlideUp(
                                isVisible,
                                delayMs = staggerDelay(index, step = 90, offset = 260)
                            )
                    )
                }
            }
        }
    }
}